import React from "react";
import "../../styles/testimonial.css";

import Slider from "react-slick";

// Replace these with appropriate images for the clients
import yenyLiscanoAvatar from "../../images/yeny-liscano-avatar.png"; // Placeholder image
import exvinAvatar from "../../images/exvin-avatar.png"; // Placeholder image
import protashAvatar from "../../images/protash-avatar.png"; // Placeholder image

const Testimonial = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 1500,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
  };

  return (
    <section>
      <div className="container">
        <div className="slider__content-top">
          <h6 className="subtitle">Testimonials</h6>
          <h2>
            Trusted by{" "}
            <span className="highlight">Our Valued Clients</span>
          </h2>
        </div>

        <div className="slider__wrapper">
          <Slider {...settings}>
            <div className="slider__item">
              <p className="description">
                "Working with Mass Trading has transformed our brand's online presence. Their innovative strategies and personalized approach truly set them apart!"
              </p>

              <div className="customer__details">
                <div className="customer__img">
                  <img src={yenyLiscanoAvatar} alt="Yeny Liscano" />
                </div>

                <div>
                  <h5 className="customer__name">Yeny Liscano</h5>
                  <p className="description">CEO, Yeny Liscano</p>
                </div>
              </div>
            </div>

            <div className="slider__item">
              <p className="description">
                "Mass Trading's expertise in digital marketing has significantly increased our brand's visibility. Their team is dedicated and professional!"
              </p>

              <div className="customer__details">
                <div className="customer__img">
                  <img src={exvinAvatar} alt="EXVIN" />
                </div>

                <div>
                  <h5 className="customer__name">EXVIN Team</h5>
                  <p className="description">Intimate Parfum</p>
                </div>
              </div>
            </div>

            <div className="slider__item">
              <p className="description">
                "Thanks to Mass Trading, we have seen a remarkable increase in customer engagement. Their digital marketing strategies are top-notch!"
              </p>

              <div className="customer__details">
                <div className="customer__img">
                  <img src={protashAvatar} alt="PROTASH" />
                </div>

                <div>
                  <h5 className="customer__name">Tashie</h5>
                  <p className="description">Founder, PROTASH</p>
                </div>
              </div>
            </div>
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
